// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './auth-api';

export const useSwitchTenant: typeof hookExports.useSwitchTenant = hookExports.useSwitchTenant;
